<template>
  <div class="w-full flex flex-col items-center justify-center px-6 py-8 mx-auto md:h-screen lg:py-0">
    <logo-app />
    <div class="w-full bg-white rounded-lg shadow dark:border md:mt-0 sm:max-w-md xl:p-0 dark:bg-gray-800 dark:border-gray-700">
      <div class="p-6 space-y-4 md:space-y-6 sm:p-8">
        <h1 class="text-xl font-bold leading-tight tracking-tight text-gray-900 md:text-2xl dark:text-white">
          {{ title }}
        </h1>
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
import LogoApp from "@/components/logo.vue";
export default {
  name: 'AuthForm',
  props: {
    title: {
      type: String,
      required: true
    }
  },
  components: { LogoApp }
}
</script>